import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CargoComponent } from "./cargo/cargo.component";
import { CheckoutAddressComponent } from "./checkout-address/checkout-address.component";
import { CheckoutComponent } from "./checkout/checkout.component";
import { CreditCardFormComponent } from "./credit-card-form/credit-card-form.component";
import { MapComponent } from "./map/map.component";
import { SelectPaymentComponent } from "./select-payment/select-payment.component";
import { SelectShipmentComponent } from "./select-shipment/select-shipment.component";
import {PaypalNativeComponent} from './paypal-native/paypal-native.component';

const routes: Routes = [
  {
    path: "",
    component: CheckoutComponent,
    children: [
       {
        path: "",
        pathMatch: "full",
        redirectTo: "shipment",
      },
      {
        path: "shipment",
        component: SelectShipmentComponent
      },
      {
        path: "paypal",
        component: PaypalNativeComponent
      },
      {
        path: "map",
        component: MapComponent,
      },
      {
        path: "cargo",
        component: CargoComponent,
      },
      {
        path: "address",
        component: CheckoutAddressComponent,
      },
      {
        path: "payment",
        component: SelectPaymentComponent,
      },
      {
        path: "credit-card",
        component: CreditCardFormComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CheckoutRoutingModule {}
